import React from "react";
import { connect } from "react-redux";
import { getCompanyAssets } from "actions/public/asset";
import { getCompanyForTooltip } from "actions/public/company";
import PropTypes from "prop-types";

import Tooltip from "components/Tooltip";
import findById from "utils/findById";

import CompanyTooltipBody from "./CompanyTooltipBody";

import styles from "./CompanyTooltip.css";

export class CompanyTooltip extends React.Component {
  constructor(props) {
    super(props);

    this.getData = this.getData.bind(this);
  }

  getData() {
    const { company, onFetchCompanyAssets, onFetchCompanyData } = this.props;
    onFetchCompanyData(company.id);
    onFetchCompanyAssets(company.id);
  }

  render() {
    const { assets, company, countryOfCurrentUser } = this.props;
    const tip = <div className={styles.tip}>{company.name}</div>;

    return (
      <div className={styles.root}>
        <Tooltip afterShow={this.getData} delayShow={500} tip={tip} keepOpen>
          <div onClick={(e) => e.stopPropagation()}>
            <CompanyTooltipBody
              assets={assets}
              company={company}
              countryOfCurrentUser={countryOfCurrentUser}
            />
          </div>
        </Tooltip>
      </div>
    );
  }
}

CompanyTooltip.propTypes = {
  countryOfCurrentUser: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.number,
  }),
  assets: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      avatar: PropTypes.string,
    })
  ),
  company: PropTypes.shape({
    logoUrl: PropTypes.string,
  }),
  onFetchCompanyData: PropTypes.func,
  onFetchCompanyAssets: PropTypes.func,
};

const mapStateToProps = (state, { company }) => ({
  assets: state.companyAssets.filter((a) => a.companyId === company.id),
  countryOfCurrentUser: state.currentUser.company.country || {},
  company: findById(state.companies, company.id) || company,
});

const mapDispatchToProps = (dispatch, { company }) => ({
  onFetchCompanyData: () => dispatch(getCompanyForTooltip(company.id)),
  onFetchCompanyAssets: () => dispatch(getCompanyAssets(company.id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CompanyTooltip);
